var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('DataViewer',{attrs:{"title":this.$t('client_information'),"data":_vm.data}}),(_vm.userQuetionHistory.length)?_c('QuestionHistory',{attrs:{"data":_vm.userQuetionHistory}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }